module.exports = {
    title: 'Treasure Raider',
    baseMultiplier: 0.2,

    prizeMultipliers: [1, 3, 5, 10, 250, 3000],
    moneyBagMultiplier: 4,

    font: 'ProximaNova',
    fontVariations: ':n4,n7',
    secondaryFont: 'SignPainter',

    parallax: 0,

    backgroundAnchor: {
        x: 0,
        y: 0,
    },

    hasBackgroundView: false,
    hasForegroundView: false,

    logoYTitle: 0,
    logoZTitle: 2,

    ticketIdX: 0,

    bgColor: 0x770028,
    primaryColor: 0xFFE186,

    volumes: {
        music: 0.8,
        win: 0.8,
        'sas-louder': 1,
        'spin-button': 0.4,
        'stop-1': 1.0,
        'stop-2': 0.8,
        'stop-3': 0.7,
    },

    styles: {
        introText: {
            fontFamily: 'ProximaNova',
            fontSize: 16,
            fontWeight: 400,
            fill: 0xFFFFFF,
            align: 'center',
            lineHeight: 23,
            wordWrap: true,
            wordWrapWidth: 260,
            stroke: 0x000000,
            strokeThickness: 3,
            lineJoin: 'round',
        },
    },
};




// WEBPACK FOOTER //
// ./themes/tr/config.js